import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.PrintSetupSettings',
    defaultMessage: 'Print Setup Settings',
    id: 'BtS7sC',
  },
});

export const hotkey = ['g', 'a', 'p'];
export const barcodeContent = '+CZ683RX55QB3=';

const GotoPrintSetupSettings = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/settings/printing'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gap'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoPrintSetupSettings.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoPrintSetupSettings;
